import { createSlice } from "@reduxjs/toolkit";
import { MessageType } from "../types/messageType";

interface stateType {
  messages: MessageType[];
}

const initialState: stateType = {
  messages: [],
};

export const messageSlice = createSlice({
  name: "messageSlice",
  initialState,
  reducers: {
    sendMessage: (state, action) => {
      const value: MessageType = {
        id: state.messages.length + 1,
        ...action.payload,
      };
      state.messages.push(value);
    },
  },
});

export const { sendMessage } = messageSlice.actions;

export default messageSlice.reducer;
